module.exports = __webpack_public_path__ + "img/top_content&technic.7566c7f1.jpg";